export default __webpack_public_path__ + "static/media/9.0b0c1179.jpg";